<template>
        <div class="py-4">
            <h4 class="mb-4 text-center font-active">Popular Categories</h4>
            <div>
                <swiper 
                    :modules="[SwiperAutoplay]"
                    :loop="true"
                    :loopAdditionalSlides="5"
                    :autoplay="{
                        delay: 2500,
                        disableOnInteraction: false,
                    }"
                    :slides-per-view="5"
                    :breakpoints="{
                        340: {
                            slidesPerView: 1.5,
                            slidesPerGroup: 1,
                            spaceBetween : 5,
                            centeredSlides : true,
                            },
                        512: {
                            slidesPerView: 2,
                            slidesPerGroup: 1,
                            spaceBetween: 20,
                            centeredSlides: false,
                            autoplay: true,
                        },
                        767: {
                            slidesPerView: 4,
                            slidesPerGroup: 1,
                            centeredSlides: false,
                            autoplay: true,
                        },    
                        992: {
                            slidesPerView: 5,
                            slidesPerGroup: 1,
                            spaceBetween: 0,
                            centeredSlides: false,
                            autoplay: true,
                        },
                    }"
                    >
                    <swiper-slide>
                        <div class="slide_box">
                            <NuxtLink :to="localePath({ name:'loose-listing', query:{ 'Shape':'Oval', 'Color': 'F,G', 'Clarity': 'VS1,VS2' } })">
                                <picture>
                                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/loose/popular/cat4.webp">
                                    <img class="radious_eight" loading="lazy" alt="Oval Value Picks" width="278" height="278" type="image/jpeg" src="~/assets/landing/loose/popular/cat4.jpg">
                                </picture>
                                <span>Oval Value Picks</span>
                            </NuxtLink>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <NuxtLink :to="localePath({ name:'loose-listing', query:{ 'Shape':'Round', 'Color': 'F,G', 'Clarity': 'VS1,VS2' } })">
                                <picture>
                                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/loose/popular/cat1.webp">
                                    <img class="radious_eight" loading="lazy" alt="Round value picks" width="278" height="278" type="image/jpeg" src="~/assets/landing/loose/popular/cat1.jpg">
                                </picture>
                                <span>Round value picks</span>
                            </NuxtLink>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <NuxtLink :to="localePath({ name:'loose-listing', query:{ 'Shape':'Pear', 'CaratFrom': 2, 'CaratTo': 15 } })">
                                <picture>
                                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/loose/popular/cat5.webp">
                                    <img class="radious_eight" loading="lazy" alt="Pears above 2 Ct" width="278" height="278" type="image/jpeg" src="~/assets/landing/loose/popular/cat5.jpg">
                                </picture>
                                <span>Pears above 2 Ct</span>
                            </NuxtLink>
                        </div>
                    </swiper-slide>
                    <swiper-slide v-if="$country.is_india">
                        <div class="slide_box">
                            <NuxtLink :to="localePath({ name:'loose-listing', query:{ 'Shape':'Round', 'PriceFrom': 0, 'PriceTo': 50000 } })">
                                <picture>
                                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/loose/popular/cat2.webp">
                                    <img class="radious_eight" loading="lazy" alt="Rounds under $5000" width="278" height="278" type="image/jpeg" src="~/assets/landing/loose/popular/cat2.jpg">
                                </picture>
                                <span>Rounds under ₹5,00,000</span>
                            </NuxtLink>
                        </div>
                    </swiper-slide>
                    <swiper-slide v-else>
                        <div class="slide_box">
                            <NuxtLink :to="localePath({ name:'loose-listing', query:{ 'Shape':'Round', 'PriceFrom': 0, 'PriceTo': 5000 } })">
                                <picture>
                                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/loose/popular/cat2.webp">
                                    <img class="radious_eight" loading="lazy" alt="Rounds under $5000" width="278" height="278" type="image/jpeg" src="~/assets/landing/loose/popular/cat2.jpg">
                                </picture>
                                <span>Rounds under $5000</span>
                            </NuxtLink>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <NuxtLink :to="localePath({ name:'loose-listing', query:{ 'Shape':'Oval', 'Color': 'D,E,F' } })">
                                <picture>
                                    <source width="278" height="278" type="image/webp" srcset="~/assets/landing/loose/popular/cat3.webp">
                                    <img class="radious_eight" loading="lazy" alt="Colorless Oval" width="278" height="278" type="image/jpeg" src="~/assets/landing/loose/popular/cat3.jpg">
                                </picture>
                                <span>Colorless Oval</span>
                            </NuxtLink>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
</template>

<script setup>
    const localePath = useLocalePath();
    const { $country } = useNuxtApp();
</script>

<style scoped>
    .slide_box{
        text-align: center;
        padding: 2%;
    }
    h4{
        font-size: 30px;
    }
    p{
        font-weight: 500;
        color: #000;
    }
    a{
        display: inline-block;
    }
    span{
        font-size: 16px;
        text-transform: capitalize;
        font-weight: 500;
        display: block;
        text-align: center;
        color: #000;
        padding-top: 5%;
    }

    @media(max-width: 767px){
        h4{
            font-size: 24px;
        }
    }
</style>
